import UIList from 'UIComponents/list/UIList';
import { categorySubMenus, toolsSubMenus } from '../../publicCatalogDropdownConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { sortOptions, getSerializedOptions } from '../../publicCatalogDropdownHooks';
import { MenuHeading } from './PublicCatalogMobileCategoriesMenu';
import MenuOption from './MenuOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TopLevelMenuContent = ({
  filtersData
}) => {
  const {
    topLevelOptionsPresent: categoryTopLevelOptionsPresent
  } = getSerializedOptions('cat', filtersData.subCategories);
  const {
    topLevelOptionsPresent: toolsTopLevelOptionsPresent
  } = getSerializedOptions('tools', filtersData.hsSoftwareFilters);
  return /*#__PURE__*/_jsxs(UIList, {
    children: [/*#__PURE__*/_jsx(MenuHeading, {
      className: "p-x-5 p-y-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.catalogPage.filters.cat.filterTitle"
      })
    }), categorySubMenus.map(subMenuName => /*#__PURE__*/_jsx(MenuOption, {
      filterName: "cat",
      isSubMenu: true,
      optionName: subMenuName
    }, subMenuName)), sortOptions(Array.from(categoryTopLevelOptionsPresent)).map(optionName => /*#__PURE__*/_jsx(MenuOption, {
      filterName: "cat",
      optionName: optionName
    }, optionName)), /*#__PURE__*/_jsx(MenuHeading, {
      className: "p-x-5 p-y-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.catalogPage.filters.tools.filterTitle"
      })
    }), toolsSubMenus.map(subMenuName => /*#__PURE__*/_jsx(MenuOption, {
      filterName: "tools",
      isSubMenu: true,
      optionName: subMenuName
    }, subMenuName)), sortOptions(Array.from(toolsTopLevelOptionsPresent)).map(optionName => /*#__PURE__*/_jsx(MenuOption, {
      filterName: "tools",
      optionName: optionName
    }, optionName))]
  });
};
export default TopLevelMenuContent;